"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
const RedeemSectionContainer_1 = __importDefault(require("./RedeemSectionContainer"));
const styled_components_1 = __importDefault(require("styled-components"));
const RedeemSectionLoggedInStyled = styled_components_1.default(RedeemSectionContainer_1.default) `
    .input-wrapper {
        max-width: 400px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 1em;
        position: relative;
        input {
            flex: 1;
            margin-right: 1em;
            padding: 10px 20px;
            border: none;
        }
        input.error {
            box-shadow: 0px 0px 0px 1.5px red;
            color: red;
        }
        input:disabled {
            pointer-events: none;
        }
        .ecr-dropdown {
            margin-right: 1em;
        }
        &.verified:before {
            content: '✓';
            font-size: 2em;
            position: absolute;
            left: -1em;
        }
        &.platformInput {
            .ecr-dropdown-list {
                z-index: 100;
            }
        }
        &.psnCountryInput {
            .ecr-dropdown-list {
                z-index: 99;
            }
        }
    }
    .error-msg {
        transition: opacity 0.3s;
        color: white;
        opacity: 0;
        margin-top: 1em;
        &.opaque {
            opacity: 1;
        }
    }
    .redeem-next {
        > span {
            margin-left: 1em;
        }
    }
    .confirm-next-section {
        display: flex;
        @media screen and ${constants_1.Device.mobileL} {
            flex-direction: column;
        }
        button {
            align-self: flex-start;
        }
    }
    .giftcard-banner {
        position: relative;
        width: 100%;
        padding: 50px 0;
        h2 {
            margin-top: 0;
        }
        p,
        h2 {
            color: white;
        }
        img {
            position: absolute;
            top: -7%;
            right: -14%;
            height: 115%;
            z-index: 10;
        }
        .redeem-link {
            font-size: 20px;
            font-weight: 900;
            line-height: 100%; /* 20px */
            text-transform: uppercase;
        }
    }
    .giftcard-box {
        padding: 40px;
        border-radius: 30px;
        background: #4d005b;
        padding-right: 30%;
    }
`;
exports.default = RedeemSectionLoggedInStyled;
//# sourceMappingURL=RedeemSectionLoggedInStyled.js.map